import React from "react";

const PrivacyPolicyUser = () => {
  return (
    <div className="min-h-screen">
      {/* Navbar */}
      <nav className="top-0 w-full z-10 shadow-lg"
      style={{ backgroundColor: "#212529" }}
      >
        <div className="container mx-auto flex justify-center items-center">
          {/* Logo */}
          <a href="#">
          <img src="images/surpeats-logo.svg" alt="Surpeats Logo" className="h-3/4" />          </a>
        </div>
      </nav>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-4">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Privacy Policy for Surpeats User App</h1>
        <h3 className="text-xl font-semibold text-gray-700 mb-6">Effective Date: 26th November 2024</h3>
        <p className="text-gray-700 mb-6">
          Surpeats (“we,” “our,” or “us”) is committed to protecting the privacy of our users (“you” or
          “users”). This Privacy Policy explains how we collect, use, and protect your personal
          information when you use the Surpeats User App (the “App”).
          <br />
          <br />
          By using the App, you agree to the collection, processing, and sharing of your information as
          described in this Privacy Policy, in accordance with the Digital Personal Data Protection Act
          (DPDPA), 2023, and other applicable laws in India.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Information We Collect</h2>
        <h3 className="text-lg font-semibold text-gray-700 mb-2">a. Personal Information</h3>
        <p className="text-gray-700 mb-4">
          When you register or use the App, we may collect:
          <br />• Name
          <br />• Email address
          <br />• Phone number
          <br />• Delivery address (if applicable)
        </p>
        <h3 className="text-lg font-semibold text-gray-700 mb-2">b. Payment Information</h3>
        <p className="text-gray-700 mb-4">
          We collect payment-related details necessary for processing orders. Payment information is
          handled securely through third-party payment gateways and is not stored directly by us.
        </p>
        <h3 className="text-lg font-semibold text-gray-700 mb-2">c. App Usage Data</h3>
        <p className="text-gray-700 mb-4">
          We collect data about your activity on the App, such as:
          <br />• Order history
          <br />• Search queries and preferences
          <br />• Time spent on the App
        </p>
        <h3 className="text-lg font-semibold text-gray-700 mb-2">d. Device and Technical Information</h3>
        <p className="text-gray-700 mb-4">
          We automatically collect information about your device, such as:
          <br />• Device type and operating system
          <br />• IP address
          <br />• Unique device identifiers
        </p>
        <h3 className="text-lg font-semibold text-gray-700 mb-2">e. Location Data</h3>
        <p className="text-gray-700 mb-4">
          With your permission, we collect your location to show nearby restaurants and offers.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Legal Basis for Processing</h2>
        <p className="text-gray-700 mb-4">
          Under the Digital Personal Data Protection Act, 2023 (DPDPA), we process your information
          based on the following grounds:
          <br />• Consent: For optional features like location tracking and marketing communications.
          <br />• Performance of Contract: To provide services like processing orders and enabling
          transactions.
          <br />• Legal Obligations: To comply with applicable laws and regulations.
          <br />• Legitimate Interests: To improve app functionality and user experience.
          <br />
          You may withdraw your consent at any time for data collected on a consent basis, though some
          features may no longer function.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">3. How We Use Your Information</h2>
        <p className="text-gray-700 mb-4">
          We use your information to:
          <br />• Register and manage your account.
          <br />• Facilitate transactions, including order placements and payments.
          <br />• Display relevant restaurants, cafes, and stores based on your location.
          <br />• Send order updates, notifications, and promotional messages.
          <br />• Enhance and personalize your app experience.
          <br />• Comply with legal and regulatory requirements.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Sharing Your Information</h2>
        <p className="text-gray-700 mb-4">
          We only share your information when necessary and in compliance with the DPDPA:
          <br />• With Partners: Limited information (e.g., order details) is shared with
          restaurants and stores to fulfill your orders.
          <br />• With Service Providers: Third-party vendors, such as payment processors
          and technical support providers, to deliver our services.
          <br />• With Authorities: To comply with legal or regulatory requirements.
          <br />• Business Transfers: In the event of a merger, acquisition, or sale, your
          information may be transferred as part of our assets.
          <br />
          We do not sell or rent your personal information to third parties.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Data Security</h2>
        <p className="text-gray-700 mb-4">
          We take data security seriously and implement measures, including:
          <br />• Secure encryption of sensitive information during storage and transmission.
          <br />• Regular security audits to prevent unauthorized access or breaches.
          <br />• Restricted access to your information on a need-to-know basis.
          <br />
          Despite these measures, no system is entirely secure. You are responsible for safeguarding
          your account credentials.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Your Rights Under DPDPA</h2>
        <p className="text-gray-700 mb-4">
          As a user, you have the following rights under the Digital Personal Data Protection Act,
          2023:
          <br />• Right to Access and Correction: You can request access to or corrections of your data.
          <br />• Right to Erasure: Request deletion of your personal data, subject to legal and
          operational requirements.
          <br />• Right to Data Portability: Obtain your data in a portable format, where applicable.
          <br />• Right to Grievance Redressal: Raise concerns if you believe your data rights
          are violated.
          <br />
          To exercise your rights, contact us using the details provided below.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Data Retention</h2>
        <p className="text-gray-700 mb-4">
          We retain your data as long as your account is active or as required by law. Once the
          retention period ends, your data is securely deleted.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Compliance with Indian Laws</h2>
        <p className="text-gray-700 mb-4">
          This Privacy Policy complies with Indian data protection and privacy laws, including:
          <br />• Digital Personal Data Protection Act, 2023 (DPDPA): Governing the
          collection, use, and storage of personal data.
          <br />• Information Technology Act, 2000: Rules for handling sensitive personal data
          or information (SPDI).
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Changes to This Privacy Policy</h2>
        <p className="text-gray-700 mb-4">
          We may update this Privacy Policy to reflect changes in our practices or legal requirements.
          Significant updates will be communicated through the App or via email.
        </p>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">10. Contact Us</h2>
        <p className="text-gray-700 mb-4">
          If you have any questions or wish to exercise your rights under DPDPA, please contact us:
          <br />
          Email: admin@surpeats.com
        </p>
      </div>

      {/* Footer */}
      <footer className="text-white py-8"
      style={{ backgroundColor: "#212529" }}
      >
        <div className="container mx-auto text-center">
          <div className="flex justify-center">
          <img src="images/surpeats-logo.svg" alt="Surpeats Logo" className="mx-auto h-32" />
          </div>
          <p>&copy; 2024 Surpeats. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicyUser;
